import React from 'react'

export const DKON_THEME = {
  Logo: (
    <img
      src="/logo-with-text.png"
      alt="logo"
      className="d-none d-md-block"
      style={{ maxWidth: '45px', borderRadius: '50px' }}
    />
  ),
}
